import { EditPOComponent } from './edit-po.component';

export default EditPOComponent;
